import React from "react";
import { Grid, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { Controller } from "react-hook-form";
import Dialog from "../Common/Dialog";
import RHFTextField from "../Common/RHFComponents/RHFTextField";
import RHFAutocomplete from "../Common/RHFComponents/RHFAutocomplete";
import RHFQuillEditor from "../Common/RHFQuillEditor";

const PromptFormDialog = ({
  open,
  isEditMode,
  handleClose,
  handleSubmit,
  control,
  onSubmit,
  llmModels,
  categoryOptions,
  systemPromptOptions,
}) => {
  return (
    <Dialog
      isOpen={open}
      cancelSubmitHandle={handleClose}
      handleClose={handleClose}
      okSubmitHandle={handleSubmit(onSubmit)}
      okBtnText={isEditMode ? "Update" : "Submit"}
      title={
        <Typography variant="h6">
          {isEditMode ? "Edit Prompt" : "Add Prompt"}
        </Typography>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <RHFTextField
              name="promptVersion"
              label="Prompt Name"
              placeholder="Enter your prompt version"
              control={control}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <RHFAutocomplete
              name="llmModel"
              control={control}
              label="Select LLM Model"
              placeholder="Choose a LLM Model"
              options={llmModels}
              required
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <RHFTextField
              name="limit"
              label="Limit"
              type="number"
              placeholder="Enter your limit"
              control={control}
              required
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <RHFAutocomplete
              name="category"
              control={control}
              label="Select Category"
              placeholder="Choose one or more categories"
              options={categoryOptions}
              multiple
              required
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <RHFAutocomplete
              name="systemPrompt"
              control={control}
              label="Select System Prompt"
              placeholder="Choose a System Prompt"
              options={systemPromptOptions}
              required
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Controller
              name="useKnowledgeBase"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value}
                      onChange={(e) => field.onChange(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="Use Knowledge Base"
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <RHFQuillEditor
              name="prompt"
              label="Prompt Content"
              required
              control={control}
              defaultValue="### Prompt Example"
            />
          </Grid>
        </Grid>
      </form>
    </Dialog>
  );
};

export default PromptFormDialog;
